import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["data-tip"]
const _hoisted_2 = ["disabled"]

import { computed } from "vue";
import { err } from "@/utils";
import { useBackendStore } from "@/stores";


export default /*@__PURE__*/_defineComponent({
  __name: 'ConfigUpdateButton',
  setup(__props) {

const backend = useBackendStore();

const error = computed(() => {
  if (backend.currentConfig == null) return null;
  if (!backend.configModified) {
    return "No changes to be saved";
  }
  if (!backend.userLoggedIn) {
    return "Log in to save your configuration";
  }
  if (!backend.userIsOwner) {
    return "This configuration cannot be modified";
  }
  return null;
});

const tooltip = computed(() => {
  if (backend.currentConfig == null) return null;
  if (error.value != null) return err(error.value);
  return "Save changes to current configuration";
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([tooltip.value != null ? 'tooltip' : '']),
    "data-tip": tooltip.value
  }, [
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(backend).updateCurrentConfig && _unref(backend).updateCurrentConfig(...args))),
      class: "btn btn-neutral w-24",
      disabled: _unref(backend).currentConfig == null || error.value != null
    }, " Save ", 8, _hoisted_2)
  ], 10, _hoisted_1))
}
}

})